import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Form, FormInstance, Input } from 'antd';

import styles from './InterviewLinkForm.module.scss';

interface InterviewLinkFormProps {
  form: FormInstance;
  onValidateUrl: (url: string) => boolean;
  disabled: boolean;
}

const InterviewLinkForm: FC<InterviewLinkFormProps> = ({
  form,
  onValidateUrl,
  disabled
}) => {
  const { t } = useTranslation();

  return (
    <Form form={form} layout="vertical" className={styles.formContainer}>
      <Form.Item
        name="meetingLink"
        label={t('interviewLink.title')}
        rules={[
          {
            required: true,
            message: t('interviewLink.inputMeetingLink')
          },
          {
            validator: (_, value) => {
              if (!value || value.trim().length === 0) {
                return Promise.resolve();
              }
              if (onValidateUrl(value.trim())) {
                return Promise.resolve();
              }
              return Promise.reject(
                new Error(t('interviewLink.inputNotValid'))
              );
            }
          }
        ]}
      >
        <Input
          placeholder={t('interviewLink.placeholder')}
          disabled={disabled}
        />
      </Form.Item>
    </Form>
  );
};

export default InterviewLinkForm;
